module.exports = __webpack_public_path__ + "img/nodata.1b3c81c5.svg";